import { css } from '@emotion/react';
import { DataSourcesQueries } from '@frontend/api-data-sources';
import { useTranslation } from '@frontend/i18n';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { theme } from '@frontend/theme';
import { Button, Text } from '@frontend/design-system';
import { NoProvidersIllustration } from '../images';
import { useCalendarStore } from '../stores';
import { CALENDAR_TRACKING_IDS } from '../trackingIds/calendar-tracking-ids';

export const EmptyCalendarMessage = () => {
  const { t } = useTranslation('schedule');
  const { navigate } = useSettingsNavigate();
  const { isIntegratedOffice, isLoading } = DataSourcesQueries.useGetAccessibleIntegrations();
  const { calendarEntityType } = useCalendarStore(['calendarEntityType']);
  const isOperatoryView = calendarEntityType === 'operatory';

  if (isLoading) {
    return null;
  }

  if (isIntegratedOffice) {
    if (isOperatoryView) {
      return (
        <section css={emptyStateContainerStyles}>
          <NoProvidersIllustration />
          <Text color='light' textAlign='center' css={{ marginTop: theme.spacing(2) }}>
            {t('Your calendar is looking a bit empty!')}
            <br />
            {t('Click here to configure your first operatory and start booking appointments.')}
          </Text>
          <Button
            onClick={() => navigate({ to: '/schedule/operatories' })}
            iconName='plus'
            trackingId={CALENDAR_TRACKING_IDS.emptyCalendar.configureOperatoriesButton}
          >
            {t('Configure Operatories')}
          </Button>
        </section>
      );
    }
    return (
      <section css={emptyStateContainerStyles}>
        <NoProvidersIllustration />
        <Text color='light' textAlign='center'>
          {t('Your calendar is looking a bit empty!')}
        </Text>
      </section>
    );
  }

  return (
    <section css={emptyStateContainerStyles}>
      <NoProvidersIllustration />
      <Text color='light' textAlign='center' css={{ marginTop: theme.spacing(2) }}>
        {t('Your calendar is looking a bit empty!')}
        <br />
        {t('Click here to add your first provider and start booking appointments.')}
      </Text>
      <Button
        onClick={() => navigate({ to: '/schedule/manage-providers' })}
        iconName='plus'
        trackingId={CALENDAR_TRACKING_IDS.emptyCalendar.addProviderButton}
      >
        {t('Add Provider')}
      </Button>
    </section>
  );
};

export const emptyStateContainerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
  position: 'absolute',
  zIndex: theme.zIndex.low,
  width: '100%',
  height: '100%',
  padding: '50px 70px',
  backdropFilter: 'blur(2px)',
});
